export const AuthActionTypes = {
  LOGIN_START: "LOGIN_START",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  CLEAR_LOGIN_SUCCESS: "CLEAR_LOGIN_SUCCESS",
  SET_CURRENT_USER: "SET_CURRENT_USER",
  LOG_OUT: "LOGOUT",
};
